var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTokenOrai = function SvgIconTokenOrai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#icon-token-orai_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.283 8.541.634 1.872h-1.43l.67-1.872h.126Zm3.42 2.874h-1.047v.368h2.58v-.368h-1.033V8.467h1.032V8.1h-2.58v.368h1.047v2.948Zm-4.71.368.354-.987H9.05l.332.987h.545L8.6 8.1h-.752L6.5 11.783h.493Zm8.298 3.508H4.71V4.71h10.582v10.582Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.031 20A10.072 10.072 0 0 0 20 11.032h-1.246c-.442 4.097-3.544 7.362-7.723 7.826V20ZM0 11.032A10.072 10.072 0 0 0 8.968 20v-1.142c-4.178-.464-7.273-3.736-7.723-7.826H0ZM20 8.968A10.072 10.072 0 0 0 11.03 0v1.142c4.179.464 7.274 3.736 7.723 7.826H20ZM8.968 0A10.072 10.072 0 0 0 0 8.968h1.245c.443-4.097 3.545-7.362 7.723-7.826V0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-token-orai_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconTokenOrai;